import * as React from "react";
import "../Assets/CSS/adminTable.css";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
interface props {
  tableData: any;
  tableHead: any;
  handleEdit?: any;
  handleDelete?: any;
  pagename?: any;
  edit?: any;
  handleCheck?: any;
}
const AdminTable = (props: props) => {
  const {
    tableData,
    tableHead,
    handleEdit,
    handleDelete,
    pagename,
    handleCheck,
  } = props;

  return (
    <>
      <div className="admin-table">
        <div className="table-responsive">
          <table className="table table-striped table-hover align-middle text-md-start text-center">
            <thead>
              <tr>
                {tableHead?.map(
                  (
                    data:
                      | string
                      | number
                      | boolean
                      | React.ReactElement<
                          any,
                          string | React.JSXElementConstructor<any>
                        >
                      | Iterable<React.ReactNode>
                      | React.ReactPortal
                      | null
                      | undefined,
                    index: React.Key | null | undefined,
                  ) => {
                    return <th key={index}>{data}</th>;
                  },
                )}
              </tr>
            </thead>
            <tbody>
              {Array.isArray(tableData) && tableData.length ? (
                tableData?.map((data, index) => {
                  return (
                    <>
                      <tr key={index}>
                        {pagename === "dispatchorder" ? (
                          data?._id ? (
                            <td>
                              <span>
                                <input
                                  id={data?._id}
                                  className="check"
                                  type="checkbox"
                                  checked={data.isSelected}
                                  onChange={(data) => {
                                    handleCheck(data, index);
                                  }}
                                />
                              </span>
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        <td>{index + 1}</td>
                        {pagename === "SubDepartmentList" ? (
                          data?.departments?.name ? (
                            <td>{data?.departments?.name}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}

                        {pagename === "DepartmentList" ||
                        pagename === "SubDepartmentList" ||
                        pagename === "DesignationList" ||
                        pagename === "ageGroup" ||
                        pagename === "ProductType" ||
                        pagename === "TagOption" ||
                        pagename === "category" ||
                        pagename === "Product" ||
                        pagename === "couponCode" ||
                        pagename === "Author" ||
                        pagename === "sellingSourceList" ? (
                          data?.name ? (
                            <td>{data?.name}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "ageGroup" ? (
                          data?.ageGroup ? (
                            <td>{data?.ageGroup}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "DesignationList" ? (
                          data?.level ? (
                            <td>{data?.level}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}

                        {pagename === "ProductType" ||
                        pagename === "TagOption" ||
                        pagename === "category" ? (
                          data?.order ? (
                            <td>{data?.order}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}

                        {pagename === "ProductType" ||
                        pagename === "category" ? (
                          data?.seoName ? (
                            <td>{data?.seoName}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {/* ******************************blogList************************************* */}
                        {pagename === "blogList" ? (
                          data?.title ? (
                            <td>{data?.title}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}

                        {/* *********************************Base Offer*********************************** */}
                        {pagename === "BaseOffer" ? (
                          !data?.gloabl &&
                          data?.productType &&
                          data?.categoryId?.name ? (
                            <td>{data?.categoryId?.name}</td>
                          ) : !data?.gloabl &&
                            data?.productType &&
                            !data?.categoryId?.name ? (
                            <td>PRODUCT TYPE</td>
                          ) : (
                            <td>GLOBAL</td>
                          )
                        ) : null}
                        {pagename === "BaseOffer" ? (
                          data?.discPer ? (
                            <td>{data?.discPer}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}

                        {/* *********************************couponCode*********************************** */}
                        {pagename === "couponCode" ? (
                          data?.startDate ? (
                            <td>
                              {moment
                                .utc(data?.startDate)
                                .utcOffset(330)
                                .format("YYYY-MM-DD HH:mm:ss")}
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "couponCode" ? (
                          data?.endDate ? (
                            <td>
                              {moment
                                .utc(data?.endDate)
                                .utcOffset(330)
                                .format("YYYY-MM-DD HH:mm:ss")}
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "couponCode" ? (
                          data?.couponType ? (
                            <td>{data?.couponType}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "couponCode" ? (
                          data?.discPer ? (
                            <td className="text-center">{data?.discPer}</td>
                          ) : (
                            <td className="text-center">0</td>
                          )
                        ) : null}

                        {/* *********************************Author*********************************** */}
                        {pagename === "Author" ? (
                          data?.designation ? (
                            <td className="text-start">{data?.designation}</td>
                          ) : (
                            <td className="text-start">-</td>
                          )
                        ) : null}

                        {pagename === "Author" ? (
                          data?.uniqueName ? (
                            <td className="text-start">{data?.uniqueName}</td>
                          ) : (
                            <td className="text-start">-</td>
                          )
                        ) : null}

                        {pagename === "Author" ? (
                          data?.uniqueLink ? (
                            <td className="text-start">{data?.uniqueLink}</td>
                          ) : (
                            <td className="text-start">-</td>
                          )
                        ) : null}

                        {/* *********************************TransactionDetails*********************************** */}
                        {pagename === "TransactionDetails" ? (
                          data?.productName ? (
                            <td>{data?.productName}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}

                        {pagename === "TransactionDetails" ? (
                          data?.productTypeDetails ? (
                            <td>{data?.productTypeDetails?.name}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}

                        {pagename === "TransactionDetails" ? (
                          data?.categoryId?.name ? (
                            <td>{data?.categoryId?.name}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "TransactionDetails" ? (
                          data?.productId?.name ? (
                            <td>{data?.productId?.name}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "TransactionDetails" ? (
                          data?.withoutGstAmount ? (
                            <td>{data?.withoutGstAmount}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "TransactionDetails" ? (
                          data?.iGST_Amount ? (
                            <td>{data?.iGST_Amount}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "TransactionDetails" ? (
                          data?.Amount ? (
                            <td>{data?.Amount}</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "TransactionDetails" ? (
                          data?.discPer ? (
                            <td>{data?.discPer} %</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}

                        {/* *********************************dispatchorder*********************************** */}

                        {pagename === "dispatchorder" ? (
                          data?.orderNo ? (
                            <td>{data?.orderNo} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchorder" ? (
                          data?.createdAt ? (
                            <td>
                              {moment
                                .utc(data?.createdAt)
                                .format("DD-MM--YYYY")}{" "}
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchorder" ? (
                          data?.users ? (
                            <td>
                              {data?.users?.firstName}{" "}
                              {data?.users?.lastName}{" "}
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchorder" ? (
                          data?.city ? (
                            <td>{data?.city} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchorder" ? (
                          data?.state ? (
                            <td>{data?.state} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchorder" ? (
                          data?.users ? (
                            <td>{data?.users?.mobileNo} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchorder" ? (
                          data?.totalOfferPrice ? (
                            <td>{data?.totalOfferPrice} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchorder" ? (
                          data?.createdAt ? (
                            <td>
                              {moment
                                .utc(data?.createdAt)
                                .format("YYYY-MM-DD")}{" "}
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {/* *********************************dispatchDetaiOrder*********************************** */}

                        {pagename === "dispatchDetaiOrder" ? (
                          data?.orderNo ? (
                            <td>{data?.orderNo} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchDetaiOrder" ? (
                          data?.createdAt ? (
                            <td>
                              {moment
                                .utc(data?.createdAt)
                                .format("DD-MM--YYYY")}{" "}
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchDetaiOrder" ? (
                          data?.users ? (
                            <td>
                              {data?.users?.firstName}{" "}
                              {data?.users?.lastName}{" "}
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchDetaiOrder" ? (
                          data?.users ? (
                            <td>
                              {data?.address?.line1}, {data?.address?.line2},{" "}
                              {data?.address?.landmark}{" "}
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchDetaiOrder" ? (
                          data?.city ? (
                            <td>{data?.city} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchDetaiOrder" ? (
                          data?.state ? (
                            <td>{data?.state} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchDetaiOrder" ? (
                          data?.address ? (
                            <td>{data?.address?.pincode} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchDetaiOrder" ? (
                          data?.users ? (
                            <td>{data?.users?.mobileNo} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchDetaiOrder" ? (
                          data?.users ? (
                            <td>{data?.users?.email} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchDetaiOrder" ? (
                          data?.products ? (
                            <td>
                              {data?.products?.map(
                                (item: any, index: number) => (
                                  <div key={index}>{item?.name}, &nbsp;</div>
                                ),
                              )}
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchDetaiOrder" ? (
                          data?.totalOfferPrice ? (
                            <td>{data?.totalOfferPrice} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "dispatchDetaiOrder" ? (
                          data?.createdAt ? (
                            <td>
                              {moment
                                .utc(data?.createdAt)
                                .format("YYYY-MM-DD")}{" "}
                            </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {/* *********************************sourceWiseAnalysis*********************************** */}
                        {pagename === "sourceWiseAnalysis" ||
                        pagename === "stateWiseAnalysis" ? (
                          data?._id ? (
                            <td>{data?._id} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "sourceWiseAnalysis" ||
                        pagename === "stateWiseAnalysis" ? (
                          data?.totalOfferPrice ? (
                            <td>{data?.totalOfferPrice} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "sourceWiseAnalysis" ||
                        pagename === "stateWiseAnalysis" ? (
                          data?.totalWithoutGstAmount ? (
                            <td>{data?.totalWithoutGstAmount} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "sourceWiseAnalysis" ||
                        pagename === "stateWiseAnalysis" ? (
                          data?.contribution ? (
                            <td>{data?.contribution.toFixed(2)} %</td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {/* *********************************ProductWiseAnalysis*********************************** */}
                        {pagename === "productWiseAnalysis" ? (
                          <>
                            {data?.productType ? (
                              <td>{data?.productType} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.category ? (
                              <td>{data?.category} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.product ? (
                              <td>{data?.product} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.totalWithoutGstAmount ? (
                              <td>{data?.totalWithoutGstAmount} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.totalIgstAmount ? (
                              <td>{data?.totalIgstAmount} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.totalOfferPrice ? (
                              <td>{data?.totalOfferPrice} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.categoryContribution ? (
                              <td>{data?.categoryContribution.toFixed(2)} %</td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.producttypeContribution ? (
                              <td>
                                {data?.producttypeContribution.toFixed(2)} %
                              </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.contribution ? (
                              <td>{data?.contribution.toFixed(2)} %</td>
                            ) : (
                              <td>-</td>
                            )}
                          </>
                        ) : null}
                        {/* *********************************RegisteredUsersList*********************************** */}
                        {pagename === "registeredUsersList" ? (
                          <>
                            {data?.firstName ? (
                              <td>{data?.firstName} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.lastName ? (
                              <td>{data?.lastName} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.createdAt ? (
                              <td>{data?.createdAt} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.stateId ? (
                              <td>{data?.stateId?.name} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.source ? (
                              <td>{data?.source}</td>
                            ) : (
                              <td>-</td>
                            )}
                          </>
                        ) : null}
                        {/* *********************************AllSourceLead*********************************** */}
                        {pagename === "allSourceLead" ? (
                          <>
                            {data?.UserCount ? (
                              <td>{data?.UserCount} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.countPercentage ? (
                              <td>{data?.countPercentage.toFixed(2)}&nbsp;%</td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.source ? (
                              <td>{data?.source} </td>
                            ) : (
                              <td>-</td>
                            )}
                          </>
                        ) : null}
                        {/* *********************************stateWiseLead*********************************** */}
                        {pagename === "stateWiseLead" ? (
                          <>
                            {data?.stateId ? (
                              <td>{data?.stateId?.name} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.UserCount ? (
                              <td>{data?.UserCount} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.countPercentage ? (
                              <td>{data?.countPercentage.toFixed(2)}&nbsp;%</td>
                            ) : (
                              <td>-</td>
                            )}
                          </>
                        ) : null}
                        {/* ***********************************TDS**************************************** */}
                        {pagename === "tdsList" ? (
                          data?.name ? (
                            <td>{data?.name} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {pagename === "tdsList" ? (
                          data?.rate ? (
                            <td>{data?.rate} </td>
                          ) : (
                            <td>-</td>
                          )
                        ) : null}
                        {/* ***************************************Vendor***************************************** */}
                        {pagename === "PublicationVendor" ? (
                          <>
                            <td key={data._id}>
                              {data.gstNumber && data.gstNumber}
                            </td>
                            <td>
                              {data?.companyName ? data?.companyName : "-"}
                            </td>
                            <td>{data?.contactPerson?.name}</td>
                            <td>{data?.contactNo}</td>
                            <td>{data?.PAN}</td>
                            <td>{data?.stateId?.name}</td>
                            <td>{data?.cityId?.name}</td>
                            <td>
                              {data?.service?.map((item: any) => (
                                <p className="mb-1">{item?.serviceName}</p>
                              ))}
                            </td>
                          </>
                        ) : null}

                        {/* ****************************************Damage Stock****************************************** */}

                        {pagename === "damageStockList" ? (
                          <>
                            {data?.product?.name ? (
                              <td>{data?.product?.name} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.productTypeId?.name ? (
                              <td>{data?.productTypeId?.name} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.productCategoryId?.name ? (
                              <td>{data?.productCategoryId?.name} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.quantity ? (
                              <td>{data?.quantity} </td>
                            ) : (
                              <td>-</td>
                            )}
                          </>
                        ) : null}
                        {/* ********************************************Selling Src Revenue Anlysis************************************************************** */}
                        {pagename === "SellingSrcRevenueAnlysis" ? (
                          <>
                            {/* {data?.product?.name ? (
                            <td>{data?.product?.name} </td>
                          ) : (
                            <td>-</td>
                          )} */}
                            {data?.products?.map((item: any, index: number) => (
                              <td className="text-dark" key={index}>
                                {item},
                              </td>
                            ))}

                            {data?.productTypeId?.name ? (
                              <td>{data?.productTypeId?.name} </td>
                            ) : (
                              <td>-</td>
                            )}

                            {data?.productCategoryId?.name ? (
                              <td>{data?.productCategoryId?.name} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.sourceId ? (
                              <td>{data?.sourceId} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.totalAmount ? (
                              <td>{data?.totalAmount} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.totalQuantity ? (
                              <td>{data?.totalQuantity} </td>
                            ) : (
                              <td>-</td>
                            )}
                          </>
                        ) : null}

                        {/* *****************************************Selling Src Analysis******************************************** */}

                        {pagename === "SellingSrcAnalysis" ? (
                          <>
                            {data?.sourceName ? (
                              <td>{data?.sourceName} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.quantity ? (
                              <td>{data?.quantity} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.amount ? (
                              <td>{data?.amount} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.contributionPer ? (
                              <td>{data?.contributionPer}% </td>
                            ) : (
                              <td>-</td>
                            )}
                          </>
                        ) : null}
                        {/* *****************************************Employee List******************************************** */}

                        {pagename === "employeeList" ? (
                          <>
                            {data?.firstName ? (
                              <td>
                                {data?.firstName} {data?.lastName}{" "}
                              </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.employeeId ? (
                              <td>{data?.employeeId} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.mobileNo ? (
                              <td>{data?.mobileNo} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.company ? (
                              <td>{data?.company?.name} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.reportingManager ? (
                              <td>{data?.reportingManager}</td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.department ? (
                              <td>{data?.department?.name}</td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.designation ? (
                              <td>{data?.designation?.name}</td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.role ? <td>{data?.role}</td> : <td>-</td>}
                          </>
                        ) : null}
                        {/* *****************************************Category Video List******************************************** */}

                        {pagename === "categoryVideo" ? (
                          <>
                            {data?.videoName ? (
                              <td>{data?.videoName} </td>
                            ) : (
                              <td>-</td>
                            )}
                            {data?.order ? <td>{data?.order} </td> : <td>-</td>}
                            {data?.videoUrl ? (
                              <td>
                                <video
                                  key={data?.videoUrl}
                                  className="videoClass d-flex align-items-center justify-content-center"
                                  controls
                                  style={{
                                    width: "200px",
                                    height: "100px",
                                  }}
                                >
                                  <source
                                    src={data?.videoUrl}
                                    type="video/mp4"
                                  />
                                </video>
                              </td>
                            ) : (
                              <td>-</td>
                            )}
                          </>
                        ) : null}
                        {/* ************************************************************************************ */}

                        {pagename === "DepartmentList" ||
                        pagename === "SubDepartmentList" ||
                        pagename === "DesignationList" ||
                        pagename === "ageGroup" ||
                        pagename === "ProductType" ||
                        pagename === "TagOption" ||
                        pagename === "category" ||
                        pagename === "Product" ||
                        pagename === "BaseOffer" ||
                        pagename === "blogList" ||
                        pagename === "couponCode" ||
                        pagename === "Author" ||
                        pagename === "sellingSourceList" ||
                        pagename === "tdsList" ||
                        pagename === "PublicationVendor" ||
                        pagename === "employeeList" ||
                        pagename === "categoryVideo" ? (
                          <td>
                            <span
                              className="text-success fw-bold cursor me-2"
                              onClick={() => handleEdit(data)}
                            >
                              <BorderColorIcon />
                            </span>

                            <span
                              className="text-danger fw-bold cursor"
                              onClick={() => handleDelete(data)}
                            >
                              <DeleteIcon />
                            </span>
                          </td>
                        ) : pagename === "dispatchorder" ? (
                          <td>
                            <span
                              className="text-success fw-bold cursor me-2"
                              onClick={() => handleEdit(data)}
                            >
                              <BorderColorIcon />
                            </span>
                          </td>
                        ) : null}
                      </tr>
                    </>
                  );
                })
              ) : (
                <tr>
                  <td>No record found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AdminTable;
